export interface ObjectKeys {
  id?: string | number;
  key?: string | number;
}

export const extractKey = <TValue extends unknown>(value: TValue): string | boolean => {
  if (value == null) return '';

  // Use the id or key property if one is present
  const { id, key } = value as ObjectKeys;
  const result = [id, key].find((o) => o != null);
  if (result) {
    return result.toString();
  }

  return typeof value === 'boolean' ? value : value.toString();
};
